import React, { useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { logOut } from "../../actions/logOut";
import getIcons from './components/getIcons';
import Dados from '../../../assets/icons/dados.svg';
import Senha from '../../../assets/icons/senha.svg';
import Sair from '../../../assets/icons/sair.svg';
import PrecisoSuporteButton from 'components/PrecisoSuporte/PrecisoSuporteButton';
import { useRoteiro } from 'context/RoteiroContext';
import UserNavigationMobile from '../userNavigation/UserNavigationMobile';
import { useAuth } from 'context/AuthContext';
import { Tooltip } from 'antd';
import { refNamesObjetosVisuaisNavBase } from 'constants/constantesRefNameObjetosVisuais';

export default function NavBase(){
	const { setReferenciaObjetosVisuais } = useRoteiro()
	const { ehUsuarioGrupoBhs, navegacoes, ValidaPermissaoAcessoRota, ObterParametrosRelatorio } = useAuth();

	const refs = refNamesObjetosVisuaisNavBase.reduce((acc, name) => {
		acc[name] = useRef(null);
		return acc;
	}, {});

	const arrayRef = refNamesObjetosVisuaisNavBase.map(name => ({
		id: name,
		ref: refs[name],
	}));

	function obterReferenciaPorNome(refName) {
	  return refs[refName] || null;
	}

	useEffect(()=>{
		setReferenciaObjetosVisuais(arrayRef)
	},[]);

	function EhMenuRelatorio(nav){
		return nav.caminho === "/relatorio"
	}
	
	function RenderizaEditarMeusDados(){
		if(ehUsuarioGrupoBhs) return;
		return (
			<NavLinkWithRef className="nav-item" to="/EditarMeusDados" ref={obterReferenciaPorNome("refMenuAtualizarMeusDadosLateral")}>
				<img src={Dados} alt="Atualizar meus dados"/>
				<span>Atualizar meus dados</span>
			</NavLinkWithRef>
		);
  	}	

  	function RenderizaBotoes(menuTipo){
		const menus = navegacoes
			.filter(nav=>nav.exibirMenuLateral)
			.filter(nav=>nav.caminho)
			.filter(nav=> menuTipo === MenuTipo.RELATORIOS ? EhMenuRelatorio(nav) : !EhMenuRelatorio(nav))
			.filter(nav => ValidaPermissaoAcessoRota(nav.caminho, ObterParametrosRelatorio(nav.caminho + `/${nav.reportID}`)))
			.sort((a, b) => a.nome.localeCompare(b.nome));
		
		if(menus.length == 0) return null;

		return (
			<>
				{menus.map(botao => {
					let reference = obterReferenciaPorNome(botao?.objetoVisual?.id)
					var caminho = botao.caminho
					if(botao.relatorioPowerBI){
						caminho += `/${botao.reportID}`
					}

					return(
						<NavLinkWithRef 
							className="nav-item" to={caminho} 
							key={botao.navegacaoPortalClienteId} 
							ref={reference}
						>
							<Tooltip title={botao.descricao} className='d-flex' placement='right'>
								<img src={getIcons(botao.nomeDoIcone)} alt={botao.nome}/>
								<span>{botao.nome}</span>
							</Tooltip>
						</NavLinkWithRef>
					)
				})}
			</>
		)
	}

	function RenderizaGrupo(){
		const botoesOutros = RenderizaBotoes(MenuTipo.OUTROS);
		const botoesRelatorios = RenderizaBotoes(MenuTipo.RELATORIOS);
		const temRelatorios = !!botoesRelatorios && React.Children.count(botoesRelatorios.props.children) > 0;

		return(
			<div className="nav-links-wrapper">		
				<div className="nav-group">
					{botoesOutros}
					<PrecisoSuporteButton key={'preciso-suporte-button'} mostrarIcone={true} ref={obterReferenciaPorNome("refMenuPrecisoSuporte")}/>
				</div>
				{temRelatorios &&
					<div className="nav-group">
						<span className="group-title">Relatórios</span> 
						{botoesRelatorios}
					</div>
				}
			</div>
		)
	}

	function RenderizaBotaoAlterarSenha(){
		return(
			ValidaPermissaoAcessoRota("/alterarsenha") &&
				<NavLinkWithRef className="nav-item" to="/alterarSenha" ref={obterReferenciaPorNome("refMenuAlterarSenhaLateral")}>
					<img src={Senha} alt="Alterar senha"/>
					<span>Alterar senha</span>
				</NavLinkWithRef>
			)
	}

	return (
		<nav className="nav-base">
				<UserNavigationMobile/>
				{RenderizaGrupo()}
				<div className="nav-base-configs">
					<h5>Configurações</h5>
					{RenderizaEditarMeusDados()}
					{RenderizaBotaoAlterarSenha()}

					<span className="nav-item" onClick={() => logOut()} ref={obterReferenciaPorNome("refSairLateral")}>
						<img src={Sair} alt="Logout"/>
						<span>Sair</span>
					</span>
				</div>
			</nav>
	);
};

const MenuTipo = Object.freeze({
  RELATORIOS: 'relatorios',
  OUTROS: 'outros'
});

const NavLinkWithRef = React.forwardRef((props, ref) => (
	<NavLink innerRef={ref} {...props} />
));